import { SubscriptionPlanBenefitsListItem } from './components/SubscriptionPlanFeaturesList/SubscriptionPlanBenefitsList';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckRedIcon } from 'app/components/icons';

export default function usePremiumBenefitsList() {
  const { t } = useTranslation();

  return React.useMemo((): SubscriptionPlanBenefitsListItem[] => {
    return [
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.unlimited_telematics_updates',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.current_machine_hours_and_status',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.current_machine_vitals',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.current_machine_fault_codes',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.accurate_location_geofence',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t('subscriptions.manage_your_plan.benefits.inhibit_restart'),
      },
      {
        icon: CheckRedIcon,
        text: t('subscriptions.manage_your_plan.benefits.aemp'),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.enhanced_notifications',
        ),
      },
    ];
  }, [t]);
}
